export default __webpack_public_path__ + "static/media/Mask of the Harbinger.220389e9.jpg";